// extracted by mini-css-extract-plugin
export default {"message":"_2eaWP6uK8pPGyHBNgd-lVc"};